import React from "react";

import "../css/testimonial.css";
import { useEffect, useState } from "react";
import axios from 'axios';
import Posts from "./Posts";
//import Pagination from "../components/Pagination";
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';


function ViewReviews() {

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitLoading2, setSubmitLoading2] = useState(false);

  const navigate = useNavigate();

  
    const fetchPosts = async () => {
      setLoading(true);
      const res = await axios.get('https://yesedacademy.com/database/reviewData.php', {
        headers: {
           'Content-Type': 'application/json; charset=utf-8',
        },
     });
      setPosts(res.data);
      setLoading(false);
    };

    useEffect(() => {

    fetchPosts();
  }, []);


  const handleDelete = async (postId) => {
    const userConfirmed = window.confirm('Are you sure you want to delete this review? This action cannot be undone.');
  
    if (userConfirmed) {
      setSubmitLoading(postId);  // Indicate loading state
  
      try {
        const response = await fetch('https://yesedacademy.com/database/reviewDelete.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ postId })  // Ensure correct body format
        });
  
        const result = await response.json();
        console.log("Response : ", result);
  
        setSubmitLoading(false);  // Stop loading state
  
        if (result.status === 'success') {
          alert(result.message);
          //navigate('/view-reviews');  
          // Use the provided navigation callback
          navigate('/view-reviews');
          fetchPosts();
  
          
        } else {
          alert(result.message);  // Show error message
        }
      } catch (error) {
        console.error('Failed to fetch:', error);
        setSubmitLoading(false);  // Stop loading state
        alert('Failed to delete the review. Please try again later.');
      }
    }
  };
  

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  // Change page
  //const paginate = pageNumber => setCurrentPage(pageNumber);
  const paginate = ({ selected }) => {
    setCurrentPage(selected + 1);
 };

 /* const previousPage = () => {
    if (currentPage !== 1) {
       setCurrentPage(currentPage - 1);
    }
 };

 const nextPage = () => {
    if (currentPage !== Math.ceil(posts.length / postsPerPage)) {
       setCurrentPage(currentPage + 1);
    }
 };*/


 

  return (
    <div className="header">
        <h2>
        Student Reviews
      </h2>
      <Posts posts={currentPosts} loading={loading} handleDelete={handleDelete} submitLoading={submitLoading} submitLoading2={submitLoading2} />
      <ReactPaginate
                  onPageChange={paginate}
                  pageCount={Math.ceil(posts.length / postsPerPage)}
                  previousLabel={'Prev'}
                  nextLabel={'Next'}
                  containerClassName={'pagination'}
                  pageLinkClassName={'page-number'}
                  previousLinkClassName={'page-number'}
                  nextLinkClassName={'page-number'}
                  activeLinkClassName={'active'}
  />
  
  

    </div>
  );
};


export default ViewReviews;